import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../icon';
import NotificationContent from '../../contexts/notification-context';

const AUTO_HIDE_MS = 2000;
const FADE_MS = 2000;

export default function Notification(props) {
  const {variant, message, icon, onDismiss} = props;
  const self = React.useRef();
  const {clearNotification} = React.useContext(NotificationContent);
  let notificationTimeout;

  React.useEffect(() => {
    if (!onDismiss) {
      notificationTimeout = setTimeout(function() {
        self.current.style.opacity = 0;
        notificationTimeout = setTimeout(function() {
          clearNotification();
        }, FADE_MS);
      }, AUTO_HIDE_MS);
    }

    return () => {
      if (notificationTimeout) {
        clearTimeout(notificationTimeout);
        notificationTimeout = undefined;
      }
    };
  }, [onDismiss]);

  return (
    <div className="container" ref={self}>
      <div className={`alert alert-${variant} ${onDismiss ? 'alert-dismissable' : ''}`}>
        {onDismiss ? (
          <button type="button" className="close" aria-hidden="true" onClick={onDismiss}>
            <i className="fas fa-times" />
          </button>
        ) : (
          <></>
        )}
        <Icon icon={icon} />
        <span className="message">{message}</span>
      </div>
    </div>
  );
}

Notification.propTypes = {
  /** The alert style. */
  variant: PropTypes.oneOf(['success', 'danger', 'info', 'warning']),
  /** The alert message. Typically an <I18n> node. */
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  /** The icon to use. Should be a FontAwesome class. */
  icon: PropTypes.string,
  /** A function to be called when this notification's close button is clicked. If undefined, no close button will be shown. */
  onDismiss: PropTypes.func,
};
